<style lang="scss" scoped>
  .question {
    padding: 40px 20px;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    border-top-left-radius: var(--global-radius);
    border-top-right-radius: var(--global-radius);
    .btn {
      padding: 10px 40px;
      margin: 10px 6px;
    }
  }
  .btn-plain {
    color: white;
    background: rgba(255,255,255,.2);
  }
  .mv {
    margin-bottom: 0px;
  }
</style>

<template>
  <div id="#reviewprompt">
    <div class="question pink" v-if="state === 'like'">
      {{ $t('ReviewPrompt.are-you-enjoying-intimately-us') }}
      <div class="mv">
        <button class="btn btn-light white" @click="state='review'">{{ $t('ExplorationComparePack.yes') }}</button>
        <button class="btn btn-light white" @click="goToFeedback">{{ $t('GMap.no') }}</button>
      </div>
    </div>
    <div class="question pink" v-else-if="state === 'review'">
      {{ $t('ReviewPrompt.will-you-please-rate') }} &amp; {{ $t('ReviewPrompt.review-this-app') }}
      <div class="mv">
        <button class="btn btn-light white" @click="doReview" v-if="!reviewing">{{ $t('ExplorationComparePack.yes') }}</button>
        <button class="btn btn-light white" v-else>Loading <spinner color="#787EFD" /></button>
        <br>
        <button class="btn btn-plain" @click="$emit('review', 'declined')">{{ $t('GMap.no') }}</button>

        <button class="btn btn-light btn-plain" @click="$emit('review', 'later')">{{ $t('EditActions.maybe-later') }}</button>
      </div>
    </div>
    <div class="question pink" v-else>
      {{ $t('DateIdeasDetail.thank-you') }}
    </div>
  </div>
</template>

<script>
import Spinner from './Spinner';
import { InAppReview } from '@capacitor-community/in-app-review';

export default {
  components: {
    Spinner,
  },
  data () {
    return {
      state: 'like',
      reviewing: false,
    }
  },
  methods: {
    async doReview () {
      this.reviewing = true;
      if (this.$store.state.appPlatform !== "web") {
        await InAppReview.requestReview();
        this.state="done";
        this.$emit('review', 'completed');
      } else {
        this.alert(this.$t('ReviewPrompt.simulate-going-to-the-review-page-for-the-apps-platform'))
        this.state="done";
        this.$emit('review', 'completed');
      }
      this.reviewing = false;
    },
    goToFeedback () {
      console.log("Called GoTo Feedback");
      this.$emit('review', 'negative');
      this.$router.push('/feedback');
    }
  }
}
</script>
